import { onMounted, onUnmounted, ref } from 'vue'

export function useProgressBar() {
    const showBar = ref(true)
    const styleElement = ref(null)

    const setNewStyleElement = () => {
        if (styleElement.value) {
            document.body.removeChild(styleElement.value)
        }
        const node = document.createElement('style')
        node.innerHTML = `
            #nprogress .bar {
                display: ${showBar.value ? 'block' : 'none'} !important;
            }
        `
        styleElement.value = node

        document.body.appendChild(node)
    }

    onMounted(() => {
        setNewStyleElement()
    })

    onUnmounted(() => {
        if (styleElement.value && document?.body?.contains(styleElement.value)) {
            document.body.removeChild(styleElement.value)
        }
    })

    const hideProgress = (hide = true) => {
        showBar.value = !hide
        setNewStyleElement()
    }

    const showProgress = () => {
        hideProgress(false)
        setNewStyleElement()
    }

    return {
        hideProgress,
        showProgress,
    }
}
